<template>
  <div class="about">
    <div class="aobut_img">
        <img src="@/assets/image/About/W020210831547975276755.png" alt="">
        <img style="height:4px;" src="@/assets/image/About/bar.png" alt="">
        <p class="big_title">{{$t('About.title')}}</p>
    </div>
    <div class="center_brief">
      <div class="fragment">
        <p class="title">{{$t('About.title_brief')}}</p>
        <div class="text">
          {{$t('About.brief')}}
        </div>
      </div>
      <div class="fragment">
        <p class="title">{{$t('About.title_position')}}</p>
        <div class="text">
        {{$t('About.position')}}
        </div>
      </div>
      <div class="fragment">
        <p class="title">  {{$t('About.title_target')}}</p>
        <div class="text">
          {{$t('About.target1')}}
        </div>
        <div class="text">
          {{$t('About.target2')}}
        </div>
      </div>

      <div class="fragment ">
        <p class="title">  {{$t('About.title_active')}}</p>
        <p class="small_title">{{$t('About.active_title_1')}}</p>
        <div class="text">
         {{$t('About.active_text_1')}}
        </div>
        <p class="small_title">  {{$t('About.active_title_2')}}</p>
        <div class="text">
           {{$t('About.active_text_2')}}
        </div>
        <p class="small_title"> {{$t('About.active_title_3')}}</p>
        <div class="text">
          {{$t('About.active_text_3')}}
        </div>
        <p class="small_title">  {{$t('About.active_title_4')}}</p>
        <div class="text">
          {{$t('About.active_text_4')}}
        </div>
        <p class="small_title"> {{$t('About.active_title_5')}}</p>
        <div class="text">
          {{$t('About.active_text_5')}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name:'About'
};
</script>

<style lang="scss" scoped>
    .about{
        width: 100%;
        .aobut_img{
            width: 100%;
            height: 350px;
            img{
                width: 100%;
                height: 300px;
                object-fit: cover;
            }
            .big_title{text-align: center;
            color: #666;
            margin-top: 10px;
            font-size: 18px;
            
            }
            
        }
        .center_brief{
            background: url("../assets/image/About/aboutbg.jpg") no-repeat;
                    background-size:cover;
                    // padding-bottom: 40px;
                 
            padding: 20px 10px 30px;
            .fragment{
                margin-bottom: 10px;
                .title{
                    font-size: 18px;
                    color: #1685a9;
                    margin-top: 20px;
                    // height: 30px;
                    padding: 8px 0 0 18px;
                    font-weight: 600;
                    margin-bottom: 10px;;
                        // height: 30px;
                     background: url("../assets/image/About/lmbg02.png") no-repeat left bottom;
                    background-size:120px 30px ;
                    // background-position: -0px -0px;
                }
                .small_title{
                    margin-top: 12px;
                    font-size: 18px;
                    color: #000;
                    font-weight: 600px;
                    margin-bottom: 12px;
                    // width: 200px;
                

                }
                .text{
                    font-size: 14px;
                    color: #333;
                    margin-bottom: 10px;
                    
                }
                // &:last-child{
                //     background: url("../assets/image/About/banner_1.png") no-repeat;
                //     background-size: 100% 100%;
                //     padding-bottom: 40px;
              
                // }
            }
        }
    }
</style>